const TermsOfService = () => (
    <div>
        <h1>Terms of Service</h1>
        <p>By using our site, you agree to the following terms and conditions...</p>
    </div>
);
export default TermsOfService;